import React, { Component } from "react"
import { NavLink } from "react-router-dom"
import { __ } from "@libs/utilities"
import { get, exec_route } from "src/libs/layouts"
import { IRoutingData } from "@libs/interfaces/layouts"
import { Callout, Intent } from "@blueprintjs/core"
import { isRouteExists } from "../data/isRouteChildren"

type FreeMenuProps = {
  menu_id: string,

}
class FreeMenu extends Component<FreeMenuProps> { 
  render() {
    console.log(this.props)
    const menuData = exec_route( get( this.props.menu_id ) )
    if (!this.props.menu_id) {
      return (
        <Callout className="p-5" intent={ Intent.DANGER }>
          { __( "Empty free menu data in sector «routes» in layouts" ) }
        </Callout>
      )
    }
    if (!menuData) {
      return (
        <div className="alert alert-danger">
          No contents in sector «{this.props.menu_id}» in layouts
        </div>
      )
    }
    const menu = menuData
    .filter((route) => { 
        return  isRouteExists( route )
    })
    .map((route: IRoutingData, i: number) => (
      <NavLink
        to={route.route}
        className="free-menu-item" 
        key={route.route + i}
      >
        <span>{__(route.title)}</span>
      </NavLink>
    )) 
    return (
      <div className="free-menu-container">
        {menu}
      </div>
    )
  }
}
export default FreeMenu
